import { createSlice } from "@reduxjs/toolkit";

export const finalSlice = createSlice({
  name: "final",
  initialState: {
    value: false,
  },
  reducers: {
    setFinal: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFinal } = finalSlice.actions;

export default finalSlice.reducer;
